export const COOKIES = {
  _R: "_r",
  ADMITAD_UID: "admitad_uid",
  UTM_SOURCE: "utm_source",
  APP: "app",
  AUTHJS_SESSION_TOKEN: "authjs.session-token",
  COUNTRY: "country",
  CPA: "_cpa",
  DEVICE_ID: "device_id",
  GA_AB: "ga_ab",
  GA_ABC: "ga_abc",
  GIFT_POPUP_IS_SHOWED: "giftPopupIsShowed",
  HIDE_DETECT_TOAST: "hide_detect_toast",
  HIDE_FEEDBACK_MODAL: "hideFeedbackModal",
  NEW_BALANCE: "newBalance",
  NEXT_LOCALE: "NEXT_LOCALE",
  NEXT_THEME: "NEXT_THEME",
  SHOWED_TOAST_USER_BALANCE: "showedToastUserBalance",
  PASS_KEY_DONT_SHOW: "passkeyDontShow",
  PAYHOLD_IS_SHOWED: "payholdIsShowed",
  PROMO_PACK_ENDTIME: "promoPackEndtime",
  RULES_ACCEPTED: "rulesAccepted",
  SECURE_AUTHJS_SESSION_TOKEN: "__Secure-authjs.session-token",
  SEGMENT_AB: "segment_ab",
  SENS: "sens",
  SINGLE_CPA: "_cpa_single",
  SUB1: "_sub1",
  SUBID: "_subid",
  SUBSCRIBE_EMAIL_IS_SHOWED: "subscribeEmailIsShowed",
  TUTOR_ART_IS_READED: "tutorArtIsReaded",
  TUTOR_DRAW_IS_READED: "tutorDrawIsReaded",
  TUTOR_HD_IS_READED: "tutorHdIsReaded",
  TUTOR_POSE_IS_READED: "tutorPoseIsReaded",
  TUTOR_READED: "tutorReaded",
  USE_GIFT_PROMO: "use_gift_promo",
  WEB: "_web",
} as const;

export const COOKIES_TIMES = {
  DAY_1: 60 * 60 * 24 * 1, // примерно 1 день в секундах
  DAY_3: 60 * 60 * 24 * 3, // примерно 3 дня в секундах
  DAY_30: 60 * 60 * 24 * 30, // примерно 3 дня в секундах
  WEEK_1: 60 * 60 * 24 * 7, // 7 дней
  YEAR_1: 60 * 60 * 24 * 365, // 1 год
};
